import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, LOCALE_ID, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { DecimalPipe, DatePipe, CurrencyPipe } from '@angular/common';
import { CoreModule } from '@app/core/core.module';
import { SharedModule } from '@app/shared/shared.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HeaderComponent } from './layouts/header/header.component';

import { AuthModule } from './modules/auth/auth.module';
import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import * as Sentry from "@sentry/angular-ivy";
import { ToastModule } from 'primeng/toast';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { MenubarModule } from 'primeng/menubar';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

import { environment } from '../environments/environment';

import { registerLocaleData } from '@angular/common';
import localeCs from '@angular/common/locales/cs';

import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename';

import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpClientModule } from '@angular/common/http';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache, ApolloLink, DefaultOptions } from '@apollo/client/core';
import { AppConfigModule } from '@app/app-config.module';
registerLocaleData(localeCs, 'cs');


const errorHandler = function() {
  if (environment.production) {
    return { provide: ErrorHandler, useValue: Sentry.createErrorHandler({
      showDialog: false,
    })};
  }

  return  { provide: ErrorHandler, useClass: ErrorHandler }  ;
}


@NgModule({
  declarations: [
    AppComponent,
    ContentLayoutComponent,
    AuthLayoutComponent,
    HeaderComponent
  ],
  imports: [
    // angular
    BrowserModule,

    // Apollo
    ApolloModule,
    HttpClientModule,

    // 3rd party
    AuthModule,
    // core & shared
    CoreModule,
    SharedModule,

    // app
    AppRoutingModule,
    ToastModule,
    ScrollPanelModule,
    PanelMenuModule,
    MenubarModule,

    BrowserAnimationsModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'cs-CZ' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'CZK'},
    {
      provide: APOLLO_OPTIONS,
      useFactory: (httpLink: HttpLink, appConfigModule: AppConfigModule) => {
        const myHttpLink = httpLink.create({
          uri: appConfigModule.config.graphqlEndpoint,
        });

        const defaultOptions: DefaultOptions = {
          watchQuery: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'ignore',
          },
          query: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
          },
        };

        return {
          cache: new InMemoryCache(),
          link: ApolloLink.from([removeTypenameFromVariables(), myHttpLink]),
          defaultOptions: defaultOptions
        };
      },
      deps: [HttpLink, AppConfigModule],
    },
    DecimalPipe,
    DatePipe,
    CurrencyPipe,
    MessageService,
    ConfirmationService,
    DialogService,
    errorHandler()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
